// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1n1YW","dragIcon":"SortableItem_dragIcon__3nCNU","disabled":"SortableItem_disabled__Hfp7y"};